import { animate, style, transition, trigger } from '@angular/animations'
import { CommonModule, NgClass, NgIf } from '@angular/common'
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  NgZone,
  Output,
  ViewChild,
  ViewRef,
  signal,
} from '@angular/core'
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { ComboBoxComponent, DropDownFilterSettings, DropDownListComponent, FilterDirective } from '@progress/kendo-angular-dropdowns'
import { IconsModule } from '@progress/kendo-angular-icons'
import { KENDO_INPUTS } from '@progress/kendo-angular-inputs'
import { KENDO_LABELS } from '@progress/kendo-angular-label'
import * as crypto from 'crypto-js'
import { format, isAfter, isBefore, parseISO, set } from 'date-fns'
import { toZonedTime } from 'date-fns-tz'
import { IndividualConfig, ToastrService } from 'ngx-toastr'
import { NgxUiLoaderModule } from 'ngx-ui-loader'
import { delay, map, merge, of } from 'rxjs'
import { environment } from '../../../../environments/environment'
import { ClientServices } from '../../../@theme/services/clients.service'
import { repingDto } from '../constructDto/transactionDto'
import { Step2TransactionFormComponent } from '../step2Transactions/step2Transactions.component'
export class products {
  productTypeId: number
}
export class selectedEvents {
  clientId: number
  firstName: string
  taxId: string
  state: string
  invObjectiveId: number
  liquidityNeedsId: number
  investmentTimeHorizonId: number
  investmentProfileId: number
  annualIncFrom: string
  annualIncTo: string
  netWorthFrom: string
  netWorthTo: string
  liquidNWFrom: string
  liquidNWTo: string
  investDescription: string
  investmentTimeHorizonDescription: string
  profileDescription: string
  liquidDescription: string
  dob: string
}
@Component({
  selector: 'gd-new-transaction',
  templateUrl: './new-transaction.component.html',
  styleUrls: ['./new-transaction.component.css'],
  animations: [
    trigger('fade', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate(2000, style({ opacity: 1 })),
      ]),
      transition('* => void', [animate(1000, style({ opacity: 0 }))]),
    ]),
  ],
  imports: [
    CommonModule,
    NgxUiLoaderModule,
    NgIf,
    IconsModule,
    FormsModule,
    ReactiveFormsModule,
    NgClass,
    ComboBoxComponent,
    FilterDirective,
    DropDownListComponent,
    Step2TransactionFormComponent,
    KENDO_INPUTS,
    KENDO_LABELS,
  ]
})
export class NewTransactionComponent implements AfterViewInit {
  showStep2Form = signal(true);
  public lblRep: string
  unsubcribe: any
  @Output() passclientId = new EventEmitter<any>()
  @ViewChild('item', { static: false }) accordion: any
  public repNamestring: string
  public hideout: boolean
  public StatusTypeId: any
  public tester = 0
  public disableFlag: boolean
  public LiquidNWTo: string
  public repwasterminated = false
  public LiquidNWFrom: string
  public NetWorthTo: string
  public NetWorthFrom: string
  public AnnualIncTo: string
  public AnnualIncFrom: string
  public queryEdit = true
  public InvestmentProfileId: number
  public InvestmentTimeHorizonId: number
  public LiquidityNeedsId: number
  public InvObjectiveId: number
  private newosjresult: number
  private cnt = 0
  public lblRepCode: string
  public lblClientName: string
  public lblProductType: string
  public ProdTypeId: string
  public lblSourceOffundsType: string
  public lblTransactionType: string
  public lblSplitRepName: string
  firstForm: FormGroup
  secondForm: FormGroup
  thirdForm: FormGroup
  public showtrue: boolean
  private producttypeIdEdit: number
  private getClientId: number
  private getRepId: number
  public showsplit: boolean
  public onVal = false
  public selectRep: number
  public loader: boolean
  public loaderCode: boolean
  public loaderTypeClient: boolean
  public loaderpt: boolean
  public RepExists = true
  public loadetrans = false
  public statusIndex0: string
  public splitreplistItems: Array<any> = []
  public clientlistItems: Array<any> = []
  public repcodelistItems: Array<any> = []
  public clientthirdlisting: Array<any> = []
  public productlisting: Array<any> = []
  public translisting: Array<any> = []
  public sourceFundtypelist: Array<any> = []
  private duration = 1000
  public style1 = false
  public style2 = false
  public style3 = false
  public style4 = false
  public style5 = false
  private index = 0
  public style6 = false
  public style7 = false
  public style8 = false
  public style9 = false
  public style10 = false
  public style11 = false
  public style12 = false
  public source = false
  public radstatus: string
  private roleString: string
  public sourceselect = false
  public RepSelected: number
  public ClientSelected: number
  public productTypeSelected: number
  public sourceselecttransfer = false
  public editsource = false
  public btnupdate = false
  public transactionTypeSelected: number
  public SourceofFundsSelected: number
  public RepCodeSelected: number
  public repCodestring: string
  public Clientstring: string
  public productTypestring: string
  public stateof: string
  private repcodeIdpull: number
  public transactionTypestring: string
  public sourceoffundsstring: string
  public LiquidDescription: string
  public InvestDescription: string
  public InvestmentTimeHorizonDescription: string
  public ProfileDescription: string
  public SplitRepTransaction = false
  public taxen: string
  public clientId: number
  public hidetoprow = true
  public dob: string
  public transactionTypeId: number
  public address1: string
  public address2: string
  public city: string
  public state: string
  public zipcode: string
  public Email: string
  public ptypes: number
  private getname: string
  public blotterIdget: number
  public showbtn = false
  private RepId: number
  private currentRole: string
  public osjValid = false
  public checkWarning = false
  public accountformTrue = false
  private getsplitrepId: number
  private storageValueReturn = localStorage.getItem('rvarietylist')
  public loading = false
  options = [
    { value: 'true', label: 'Yes' },
    { value: 'false', label: 'No' },
  ]
  option: any
  public selectedItem: number = this.productlisting[1]
  public virtual: any = {
    itemHeight: 30,
  }
  public filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: 'startsWith',
  }
  private selectedSourceOfFunds = ''
  constructor(
    private toastrService: ToastrService,
    private route: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private cliservice: ClientServices,
    private ngZone: NgZone,
  ) {
    this.firstForm = this.fb.group({
      RepId: [0, Validators.required],
      repCodeId: ['', Validators.required],
      clientTax: new FormControl(
        { value: '', disabled: true },
        Validators.required,
      ),
      productTypeId: new FormControl(
        { value: 0, disabled: true },
        Validators.required,
      ),
      transact: ['', Validators.required],
      sourcetypes: ['', Validators.required],
      SplitRepId2: ['false', Validators.required],
      SplitRepId: [''],
      Amount: [0, [Validators.min(0), Validators.max(999999999)]],
    })

    this.secondForm = this.fb.group({
      secondCtrl: ['', Validators.required],
    })
    this.thirdForm = this.fb.group({
      thirdCtrl: ['', Validators.required],
    })
    this.loaderfirst()
  }
  ngAfterViewInit() {
    this.someAsyncOperation()
  }
  someAsyncOperation(): void {
    this.SplitRepTransaction = this.showsplit
    this.repwasterminated = false
    this.cnt = 0
    this.loaderpt = true
    this.source = false
    this.onVal = false
    this.radstatus = 'danger'
    sessionStorage.removeItem('changeoftype')
    this.showbtn = false
    return
  }

  loaderfirst(): void {
    const paramT =
      crypto.AES.decrypt(this.storageValueReturn, environment.securepw);
    const decrypted = paramT.toString(crypto.enc.Utf8);


    const checkParamT = decodeURI(decrypted) // ##############  Get Current Role.  ###################
    if (checkParamT.toLowerCase() === 'rep'.toLowerCase()) {
      this.RepExists = false
    }
    const param = { role: checkParamT }
    this.cliservice.getproductypelist(param).subscribe((r) => {
      this.productlisting = r
      this.loaderpt = false
      this.GetTransactionTypes()
    })
    if (!this.route.snapshot.queryParams['Rview']) {
      // Only Edit *****
      if (localStorage.getItem('branch_num') === null) {
        this.GetClientList()
      } else {
        this.GetClientListbyBranch()
      }
      if (this.route.snapshot.queryParams['Rview']) {
        this.route.queryParams.subscribe((params) => {
          const getblotterClient = crypto.AES.decrypt(
            params['Rview'],
            environment.securepw,
          ).toString(crypto.enc.Utf8)
          this.blotterIdget = Number(getblotterClient) // blotterId
          crypto.AES.decrypt(
            params['rId'].trim(),
            `${environment.securepw.trim()}`,
          ).toString(crypto.enc.Utf8)
        })
      }
    }

    if (this.route.snapshot.queryParams['R']) {
      this.route.queryParams.subscribe((params) => {
        const getclient = crypto.AES.decrypt(
          params['R'],
          `${environment.securepw}`,
        ).toString(crypto.enc.Utf8)
        const getreps = crypto.AES.decrypt(
          params['Rp'],
          `${environment.securepw}`,
        ).toString(crypto.enc.Utf8)
        this.getRepId = Number(getreps)
        this.getClientId = Number(getclient)
      })
    }
  }
  checkId() {
    if (this.getRepId === undefined) {
      if (this.firstForm.value.RepId) {
        this.style1 = false
        this.style2 = true
      } else {
        this.style1 = true
        this.style2 = false
      }
    } else {
      this.style1 = false
      this.style2 = true
    }
    if (this.firstForm.value.repCodeId) {
      this.style3 = false
      this.style4 = true
    } else {
      this.style3 = true
      this.style4 = false
    }
    if (this.getClientId === undefined) {
      if (this.firstForm.value.clientTax) {
        this.style5 = false
        this.style6 = true
      } else {
        this.style5 = true
        this.style6 = false
      }
    } else {
      this.style5 = false
      this.style6 = true
    }
    if (this.firstForm.value.productTypeId) {
      this.style7 = true
      this.style8 = false
    } else {
      this.style7 = false
      this.style8 = true
    }
    if (this.firstForm.value.transact) {
      this.style9 = false
      this.style10 = true
    } else {
      this.style9 = true
      this.style10 = false
    }
    if (this.firstForm.value.SplitRepId) {
      this.getsplitrepId = this.firstForm.value.SplitRepId
      this.style11 = false
      this.style12 = true
    } else {
      this.style11 = true
      this.style12 = false
    }
    if (this.repcodeIdpull !== 0) {
      this.firstForm.get('repCodeId').setValue(this.repcodeIdpull)
    }
    this.cdr.detectChanges()
  }
  GetClientList() {
    this.loader = true
    this.cliservice.getRepListAll().subscribe((c) => {
      this.clientlistItems = c.map((item: any) => {
        return { ...item, fullName: `${item.lastName} ${item.firstName}` }
      })
      this.loader = false
      if (this.getRepId !== undefined) {
        this.firstForm.get('RepId').setValue(Number(this.getRepId))
        this.GetRepCodeList(this.getRepId)
        this.GetClientListing(this.getRepId) // Get List of Reps
        this.firstForm.controls['RepId'].disable()
        this.firstForm.controls['productTypeId'].enable()
        this.style2 = true
        this.firstForm.controls['SplitRepId'].setValue(0)
        const repNameSelect = this.clientlistItems.find(
          (x) => x.repId === Number(this.getRepId),
        )
        if (repNameSelect === undefined) {
          this.repwasterminated = true
          this.firstForm.controls['RepId'].enable()
          return
        }
        this.repNamestring = repNameSelect?.lastName
        if (this.route.snapshot.queryParams['R']) {
          this.route.queryParams.subscribe((params) => {
            if (params['R']) {
              crypto.AES.decrypt(
                params['R'],
                `${environment.securepw}`,
              ).toString(crypto.enc.Utf8)
              this.RepSelected = repNameSelect?.repId
              this.repNamestring = repNameSelect?.lastName
              this.Email = repNameSelect?.email
            }
          })
        }
        return
      }
    })
  }
  GetClientListbyBranch() {
    this.loader = true
    const bNum = localStorage.getItem('branch_num')
    const convertbnumber = { branchNumber: Number(bNum) }
    this.cliservice.getClientListbyBranch(convertbnumber).subscribe((c) => {
      this.clientlistItems = c
      this.loader = false
      if (this.getRepId !== undefined) {
        this.firstForm.get('RepId').setValue(Number(this.getRepId))
        this.GetRepCodeList(this.getRepId)
        this.GetClientListing(this.getRepId)
        this.firstForm.controls['RepId'].disable()
        this.firstForm.controls['productTypeId'].enable()
        this.style2 = true
        // this.firstForm.controls['SplitRepId'].setValue(0)
        this.firstForm.controls['SplitRepId'].setValue(this.getsplitrepId)
        return
      }
    })
  }
  GetClientListEdit(RepId: number, ClientId: number) {
    // alert('getclient')
    this.loader = true
    this.cliservice.getRepListAll().subscribe((c) => {
      this.clientlistItems = c.map((item: any) => {
        return { ...item, fullName: `${item.lastName} ${item.firstName}` }
      })
      this.loader = false
      if (RepId !== undefined) {
        const getmyRepId = Number(RepId)
        this.RepId = getmyRepId
        this.firstForm.get('RepId').setValue(getmyRepId)
        this.GetRepCodeList(getmyRepId)
        this.GetClientListing(RepId, ClientId) // Get list of Client
        this.firstForm.controls['RepId'].enable()
        this.firstForm.controls['productTypeId'].enable()
        this.style2 = true
        this.firstForm.controls['SplitRepId'].setValue(0)
        const repNameSelect = this.clientlistItems.find(
          (x) => x.repId === Number(this.getRepId),
        )
        this.firstForm.controls['SplitRepId'].setValue(this.getsplitrepId)
        this.repNamestring = repNameSelect?.lastName
        this.RepSelected = this.firstForm.value?.RepId
        if (this.route.snapshot.queryParams['R']) {
          this.route.queryParams.subscribe((params) => {
            if (params['R']) {
              this.RepSelected = repNameSelect.repId
              this.repNamestring = repNameSelect.lastName
              this.Email = repNameSelect.email
            }
          })
        }
        return
      }
    })
  }
  togglehidetoprow() {
    this.hidetoprow = true
  }
  togglehidetoshow() {
    this.hidetoprow = false
  }
  prev() {
    this.showtrue = false
  }
  show2() {
    this.firstForm.controls['productTypeId'].setErrors({ incorrect: true })
  }
  show() {
    if (this.firstForm.valid) {
      this.showtrue = true
    }
    this.repwasterminated = false
    this.RepSelected = this.getRepId
      ? this.getRepId
      : this.firstForm.value.RepId
    this.lblRep = this.firstForm.value.transact
    this.ClientSelected = this.getClientId
      ? this.getClientId
      : this.firstForm.value.clientTax
    const param = {
      clientId: this.ClientSelected,
      repId: this.RepSelected,
      clientname: this.Clientstring,
    }
    this.passclientId.emit(param)
    this.productTypeSelected =
      this.firstForm.value.productTypeId !== undefined
        ? this.firstForm.value.producTypeId
        : this.producttypeIdEdit
    if (this.productTypeSelected === undefined) {
      this.productTypeSelected = this.firstForm.value.productTypeId
    }
    this.transactionTypeSelected = this.firstForm.value.transact
    this.SourceofFundsSelected = this.firstForm.value.sourcetypes
    this.RepCodeSelected = this.firstForm.value.repCodeId
    this.repCodestring = this.repcodelistItems.find(
      (f) => f.repCodeId === this.firstForm.value.repCodeId,
    )?.repCode
    this.productTypestring = this.productlisting.find(
      (f) => f.productTypeId === this.productTypeSelected,
    )?.productTypeDesc2
    this.transactionTypestring = this.translisting.find(
      (f) => f.transactionTypeId === this.transactionTypeSelected,
    )?.transactionTypeDesc
    this.sourceoffundsstring =
      this.SourceofFundsSelected === 0
        ? ''
        : this.sourceFundtypelist.find(
          (f) => f.sourceOfFundsTypeId === this.SourceofFundsSelected,
        )?.sourceOfFundsTypeDesc
    this.osjValidatorload()
  }
  GetRepCodeList(repcode: number) {
    this.loaderCode = true
    const param = { RepId: repcode }
    this.cliservice.getRepCodeList(param).subscribe((r) => {
      this.repcodelistItems = r
      this.loaderCode = false
    })
  }
  GetClientListing(repcode: number, clientId?: number) {
    this.loaderTypeClient = true
    const param = { RepId: repcode, ClientId: clientId }
    if (clientId !== undefined) {
      const clId = clientId.toString()
      localStorage.setItem('clId', clId.toString())
    }
    this.cliservice.getClientRepIdList(param).subscribe((r) => {
      this.clientthirdlisting = r

      if (this.getClientId !== undefined) {
        setTimeout(
          () =>
            this.firstForm.get('clientTax').setValue(Number(this.getClientId)),
          1000,
        )
        setTimeout(() => (this.loaderTypeClient = false), 1000)
        if (!this.route.snapshot.queryParams['Rview']) {
          this.firstForm.controls['clientTax'].disable()
        }
        this.style6 = true
        const paramVal = this.clientthirdlisting.filter(
          (x) => x.clientId === Number(this.getClientId),
        )
        this.selectionChangeClient(paramVal[0])
        this.loaderTypeClient = false
        return
      } else {
        this.loaderTypeClient = false
      }
    })
  }
  GetTransactionTypes() {
    this.loadetrans = true
    this.cliservice.getTransactionTypelist().subscribe((r) => {
      this.translisting = r
      this.translisting = this.translisting.filter(
        (t) => t.transactionTypeId !== 6,
      )
      this.loadetrans = false
    })
    this.firstForm.markAsDirty()
    this.showbtn = false
  }
  GetSourceofFundTypes(value: number) {
    const param = { classID: value }
    this.cliservice.getsourceoffundtypelist(param).subscribe((r) => {
      this.sourceFundtypelist = r
    })
    this.firstForm.markAsDirty()
  }
  onFirstSubmit() {
    this.firstForm.markAsDirty()
  }
  public findInvalidControls() {
    const invalid = []
    const controls = this.firstForm.controls
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name)
        this.getname = name
        this.showToaster(0)
      }
    }
    return invalid
  }
  showToaster(duration) {
    this.toastrService.show(this.getname, `You are missing a value :`)
  }
  isBlank(str) {
    return !str || /^\s*$/.test(str)
  }
  async onSecondSubmit(b) {
    this.loading = true
    this.firstForm.value.valid = false
    if (!this.isBlank(b.ccemails)) {
      if (!b.ccemails.isArray) {
        b.ccemails = ['' + b.ccemails + '']
      }
    } else {
      b.ccemails = null
    }
    if ((await this.osjValidatorload()) === false) {
      return false
    }
    const x = b.Amount
    const y: number = +x
    if (this.firstForm.value.SplitRepId == '') {
      this.firstForm.value.SplitRepId = 0
    }
    const dateSubmitted3: Date | null = b.datesubmitted
      ? new Date(b.datesubmitted)
      : null
    b.Amount = y
    b.ClientId = this.clientId ? this.clientId : this.firstForm.value.clientTax
    b.ProductTypeId = Number(this.ProdTypeId)
      ? Number(this.ProdTypeId)
      : this.firstForm.value.productTypeId
    b.TransactionTypeID = this.transactionTypeId
      ? this.transactionTypeId
      : this.firstForm.value.transact
    b.SourceOfFundsID = this.SourceofFundsSelected
    b.AnnualIncFrom = this.AnnualIncFrom
    b.AnnualIncTo = this.AnnualIncTo
    b.NetWorthFrom = this.NetWorthFrom
    b.datesubmitted = dateSubmitted3
    b.NetWorthTo = this.NetWorthTo
    b.LiquidNwfrom = this.LiquidNWFrom
    b.LiquidNWTo = this.LiquidNWTo
    b.SplitRepTransaction = this.firstForm.value.SplitRepId2
    b.SplitRepId = this.firstForm.value.SplitRepId
    b.RepCodeId = this.firstForm.value.repCodeId
    b.RepId = this.RepSelected
    b.blotterId = this.blotterIdget ? this.blotterIdget : 0
    b.Email = this.Email
    const param = {
      blotinfo: b,
      comments: b.comments,
      datesubmitted: dateSubmitted3,
    }
   // console.log('a' + JSON.stringify(param))
    this.cliservice.SubmitblotterInfo(param).subscribe({
      next: () => this.SubmitblotterInfoSuccess(b.blotterId),
      error: () => this.SubmitblotterInfoError(),
    })
    return null;
  }
  AlertMsg(b: number) {
    sessionStorage.setItem('blotterIdFiltered', b.toString())
  }
  SubmitblotterInfoSuccess(b: number) {
    this.AlertMsg(b)
    this.firstForm.value.valid = false
    this.loading = false
    return this.reRoute()
  }

  reRoute() {
    return this.router.navigate(['/pages/viewaccounts/view-accounts'])
  }
  SubmitblotterInfoError(): void {
    this.toastrService.error(
      'Your Form did not save, Please try again.',
      'Error',
    )
    this.firstForm.value.valid = true
    this.loading = false
    return
  }
  showToasts(
    status: 'success' | 'error' | 'info' | 'warning',
    message: string,
    position: 'toast-top-right' | 'toast-bottom-right' | 'toast-top-left' | 'toast-bottom-left' = 'toast-top-right',
    destroyByClick = true
  ) {
    const config: Partial<IndividualConfig> = {
      positionClass: position,
      closeButton: destroyByClick,
      progressBar: true,
      timeOut: 3000,
    };

    switch (status) {
      case 'success':
        this.toastrService.success(message, '', config);
        break;
      case 'error':
        this.toastrService.error(message, '', config);
        break;
      case 'info':
        this.toastrService.info(message, '', config);
        break;
      case 'warning':
        this.toastrService.warning(message, '', config);
        break;
      default:
        this.toastrService.show(message, '', config);
        break;
    }
  }
  showToastpst(status: 'success' | 'error' | 'info' | 'warning', message: string) {
    switch (status) {
      case 'success':
        this.toastrService.success(message, 'Success');
        break;
      case 'error':
        this.toastrService.error(message, 'Error');
        break;
      case 'info':
        this.toastrService.info(message, 'Info');
        break;
      case 'warning':
        this.toastrService.warning(message, 'Warning');
        break;
      default:
        this.toastrService.show(message);
        break;
    }
  }
  public onFocus(combo) {
    if (!combo.isOpen) {
      combo.toggle(true)
    }
  }
  public onFocus2(combo2) {
    if (!combo2.isOpen) {
      combo2.toggle(true)
    }
  }
  /*
   * Rep
   */
  public selectionChange(event: any) {
    if (event) {
      this.firstForm.reset
      this.showtrue = false
      this.firstForm.controls['repCodeId'].setValue(null)
      this.firstForm.controls['repCodeId'].setErrors({ incorrect: true })

      this.firstForm.controls['clientTax'].setValue(null)
      this.firstForm.controls['clientTax'].setErrors({ incorrect: true })

      this.firstForm.controls['productTypeId'].setValue(null)
      this.firstForm.controls['productTypeId'].setErrors({ incorrect: true })

      this.firstForm.controls['transact'].setValue(null)
      this.firstForm.controls['transact'].setErrors({ incorrect: true })

      this.firstForm.controls['sourcetypes'].setValue(0)
      this.source = false
      this.RepId = event.repId
      this.GetRepCodeList(event.repId)
      this.GetClientListing(event.repId)
      this.firstForm.controls['clientTax'].enable()
      this.firstForm.controls['productTypeId'].enable()
      this.RepSelected = event.repId
      this.repNamestring = event.lastName
      this.Email = event.email
    }
  }
  public selectionChangeRepCode(event: any) {
    if (event.repCode) {
      this.splitreplistItems = []
      const repCodeParts = event.repCode.split(' : ')
      const getRepId = this.firstForm.get('RepId').value
      const param = { RepCode: repCodeParts[0], RepId: Number(getRepId) }
      this.cliservice.getRepCodescodeList(param).subscribe((c) => {
        if (c.length > 0) {
          this.firstForm.controls['SplitRepId2'].setValue('true')
          this.firstForm.get('SplitRepId2').enable()
          this.hideout = false
        }
        if (c.length.toString() === '0') {
          this.firstForm.controls['SplitRepId2'].setValue('false')
          setTimeout(() => {
            this.firstForm.get('SplitRepId2').disable()
          }, 100)
          this.hideout = true
        }
        this.splitreplistItems = c.map((item: any) => {
          return { ...item, fullName: `${item.lastName} ${item.firstName}` }
        })
      })
      this.repCodestring = event.repCode
      this.showtrue = false
    }
  }

  /*
   * Client
   */
  public selectionChangeClient(event: selectedEvents) {
    this.showtrue = false
    this.clientId = event?.clientId
    this.Clientstring = event?.firstName
    this.taxen = event?.taxId
    this.stateof = event?.state
    this.InvObjectiveId = event?.invObjectiveId
    this.LiquidityNeedsId = event?.liquidityNeedsId
    this.InvestmentTimeHorizonId = event?.investmentTimeHorizonId
    this.InvestmentProfileId = event?.investmentProfileId
    this.AnnualIncFrom = event?.annualIncFrom
    this.AnnualIncTo = event?.annualIncTo
    this.NetWorthFrom = event?.netWorthFrom
    this.NetWorthTo = event?.netWorthTo
    this.LiquidNWFrom = event?.liquidNWFrom
    this.LiquidNWTo = event?.liquidNWTo
    this.InvestDescription = event?.investDescription
    this.InvestmentTimeHorizonDescription =
      event?.investmentTimeHorizonDescription
    this.ProfileDescription = event?.profileDescription
    this.LiquidDescription = event?.liquidDescription
    const dobString = event?.dob;            // e.g. "2025-07-10T14:30:00Z"
    if (dobString) {
      const parsedDate = parseISO(dobString);
      this.dob = format(parsedDate, 'MM-dd-yyyy');
    } else {
      this.dob = '';
    }
    const clId = this.clientId?.toString()
    if (clId !== undefined) {
      localStorage.setItem('clId', clId.toString())
    }
    if (this.route.snapshot.queryParams['Rview'] !== undefined) {
      this.editsource = true
      this.StatusTypeId = -2
      sessionStorage.setItem('changeoftype', 'true')
    }
  }
  NaviagetoPage() {
    const saveRepId = this.firstForm.get('RepId').value
    const paramrepId = crypto.AES.encrypt(
      encodeURI(saveRepId).trim(),
      environment.securepw.trim(),
    ).toString()
    this.router.navigate(['/pages/AccountForm/add-account'], {
      queryParams: { reid: paramrepId },
    })
  }
  async changestatus(v: any) {
    // Toggle signal to force reload of step 2 form
    this.showStep2Form.set(false);
    setTimeout(() => {
      this.showStep2Form.set(true);
    }, 50);
    // Force form to be invalid then valid to trigger UI refresh
    this.firstForm.markAsTouched();
    this.firstForm.setErrors({ custom: true });
    setTimeout(() => {
      this.firstForm.setErrors(null);
      this.cdr.markForCheck();
      this.cdr.detectChanges();
    }, 50);
    const numValue = typeof v === 'string' ? parseInt(v, 10) : v;
    this.SourceofFundsSelected = numValue;
    this.firstForm.get('sourcetypes').setValue(numValue);
    this.radstatus = 'success';

    // Step 2: Set UI flags for source types
    this.sourceselect = numValue === 11;
    this.sourceselecttransfer = numValue === 15;

    // Step 3: Find the source description
    const sourceObj = this.sourceFundtypelist.find(
      (f) => f.sourceOfFundsTypeId === numValue
    );
    const sourceDesc = sourceObj ? sourceObj.sourceOfFundsTypeDesc : '';
    this.sourceoffundsstring = sourceDesc;

    // Step 4: Run async time check and OSJ validation
    if (sourceDesc) {
      if (this.selectedSourceOfFunds.length === 0) {
        this.selectedSourceOfFunds = sourceDesc;
      }
     /*  if (this.selectedSourceOfFunds !== sourceDesc) {
        this.selectedSourceOfFunds = sourceDesc;
        this.firstForm.controls['sourcetypes'].setErrors({ incorrect: true });
        this.osjValid = await this.osjValidator(sourceDesc);

        const repControl = this.firstForm.get('RepId');
        // ─── date-fns version ─────────────────────────────
        const timezone = 'America/New_York';
        const nowInNY = toZonedTime(new Date(), timezone);
        const cutoffInNY = set(nowInNY, {
          hours: 13,
          minutes: 59,
          seconds: 59,
          milliseconds: 0,
        }); */
        // ────────────────────────────────────────────────

        /* const repId = repControl.value;
        const rep: repingDto = await this.cliservice.getRepByIdAsync({ repId });

        // replace moment.isAfter with date-fns isAfter
        if (sourceDesc === 'Check' && isAfter(nowInNY, cutoffInNY)) {
          if (!rep.overrideOsjwarning) {
            this.checkWarning = true;
          }
        } else {
          this.checkWarning = false;
        } */
      //}
    }
  }
  /*
   *Transaction Type
   */
  selectionChangetypes(t) {
    this.firstForm.controls['SplitRepId'].setErrors({ incorrect: true })
    if (this.cnt !== 0) {
      this.firstForm.controls['transact'].setErrors({ incorrect: true })
    }
    this.cnt++
    this.transactionTypeId = t.transactionTypeId
    this.showtrue = false
    this.source = false
    this.onVal = false // disable productType
    this.source = false // Hide source of funds
    this.firstForm.controls['SplitRepId'].setErrors(null)
    if (this.ptypes === 14 || this.ptypes === 13) {
      this.source = false
      this.accountformTrue = false
      this.firstForm.controls['sourcetypes'].setValue(0)
      this.cdr.detectChanges()
      return
    }
    if (t.transactionTypeId === 1 || t.transactionTypeId === 2) {
      this.source = true
      this.accountformTrue = false
      this.firstForm.controls['sourcetypes'].setValue('')
      this.cdr.detectChanges()
      return
    }
    if (t.transactionTypeId === 3) {
      this.source = false
      this.accountformTrue = false
      this.firstForm.controls['sourcetypes'].setValue(0)
      this.cdr.detectChanges()
      return
    }
    if (t.transactionTypeId === 4) {
      this.source = false
      this.accountformTrue = false
      this.firstForm.controls['sourcetypes'].setValue(0)
      // this.show()
      this.cdr.detectChanges()
      return
    }
    if (t.transactionTypeId === 5) {
      this.source = false
      this.accountformTrue = true
      this.firstForm.controls['sourcetypes'].setValue('')
      this.cdr.detectChanges()
      return
    }
  }
  cpSubmit() {
    const blot1 = 0
    const param = crypto.AES.encrypt(
      encodeURI(blot1.toString()).trim(),
      environment.securepw.trim(),
    ).toString()
    const paramcli = crypto.AES.encrypt(
      encodeURI(this.clientId.toString()).trim(),
      environment.securepw.trim(),
    ).toString()
    const statustype = -2
    const paramstatustype = crypto.AES.encrypt(
      encodeURI(statustype.toString()).trim(),
      environment.securepw.trim(),
    ).toString()
    const paramtransactiontype = crypto.AES.encrypt(
      encodeURI(this.transactionTypeId.toString()).trim(),
      environment.securepw.trim(),
    ).toString()
    const paramproducttype = crypto.AES.encrypt(
      encodeURI(this.producttypeIdEdit.toString()).trim(),
      environment.securepw.trim(),
    ).toString()
    const paramrepencode = crypto.AES.encrypt(
      encodeURI(this.getRepId.toString()).trim(),
      environment.securepw.trim(),
    ).toString()
    const paramrepcodeId = crypto.AES.encrypt(
      encodeURI(this.firstForm.value.repCodeId.toString()).trim(),
      environment.securepw.trim(),
    ).toString()
    // alert(this.firstForm.value.repCodeId);
    this.router.navigate(['/pages/TabsScreen/tab-views'], {
      queryParams: {
        RviewAccount: param,
        Cld: this.clientId,
        rId: paramrepencode,
        ReviewShow: true,
        clientId: paramcli,
        statustype: paramstatustype,
        transaction: paramtransactiontype,
        product: paramproducttype,
        paramAccReview: 'Transaction',
        reviewtrans: false,
        accountformrvew: true,
        reviewtransShow: true,
        splitrepId: this.firstForm.value.SplitRepId,
        repunencrypt: this.getRepId,
        edittransactionShow: true,
        repCodeId: paramrepcodeId,
      },
    })
  }
  handleFilter() {
    this.tester++
    if (this.route.snapshot.queryParams['Rview'] !== undefined) {
      sessionStorage.setItem('changeoftype', 'true')
      this.showtrue = false
    }

    const checktransvalue = this.firstForm.get('transact').value
    const productTypeIds = this.firstForm.get('productTypeId').value
    if (checktransvalue === 1) {
      if (
        productTypeIds === 14 ||
        productTypeIds === 13
      ) {
        this.firstForm.controls['sourcetypes'].setValue(0)
        this.source = false
      } else {
        this.source = true
      }
    }
    if (checktransvalue === 2) {
      if (
        productTypeIds === 14 ||
        productTypeIds === 13
      ) {
        this.firstForm.controls['sourcetypes'].setValue(0)
        this.source = false
      } else {
        this.source = true
      }
    }
    if (checktransvalue === 3) {
      this.firstForm.controls['sourcetypes'].setValue(0)
      this.firstForm.controls['SplitRepId'].setValue(0)
    }
    if (checktransvalue === 4) {
      this.firstForm.controls['SplitRepId'].setValue(0)
      this.firstForm.controls['sourcetypes'].setValue(0)
    }

    this.show()
  }
  selectionChangeProductTypes(t: products) {
    this.ptypes = null
    this.producttypeIdEdit = t.productTypeId
    this.showtrue = false
    this.firstForm.controls['transact'].setValue(null)
    this.firstForm.controls['transact'].setErrors({ incorrect: true })

    if (t.productTypeId === 6) {
      this.GetSourceofFundTypes(7)
    }
    if (t.productTypeId === 4) {
      this.GetSourceofFundTypes(8)
    }
    if (t.productTypeId === 2) {
      this.GetSourceofFundTypes(6)
    }
    if (t.productTypeId === 18) {
      this.GetSourceofFundTypes(6)
    }
    if (t.productTypeId === 9) {
      this.GetSourceofFundTypes(5)
    }
    if (t.productTypeId === 7) {
      this.GetSourceofFundTypes(4)
    }
    if (t.productTypeId === 5) {
      this.GetSourceofFundTypes(3)
    }
    if (t.productTypeId === 16) {
      this.GetSourceofFundTypes(2)
    }
    if (t.productTypeId === 8) {
      this.GetSourceofFundTypes(1)
    }
    if (t.productTypeId === 10) {
      this.GetSourceofFundTypes(9)
    }
    if (t.productTypeId === 1) {
      this.GetSourceofFundTypes(11)
    }
    if (t.productTypeId === 12) {
      this.GetSourceofFundTypes(12)
    }
    if (t.productTypeId === 11) {
      this.GetSourceofFundTypes(13)
    }
    if (t.productTypeId === 3) {
      this.GetSourceofFundTypes(14)
    }
    if (t.productTypeId === 17) {
      this.GetSourceofFundTypes(17)
    }
    if (t.productTypeId === 15) {
      this.GetSourceofFundTypes(17)
    }
    if (t.productTypeId === 15) {
      this.GetSourceofFundTypes(15)
    }
    if (t.productTypeId === 13) {
      this.firstForm.controls['sourcetypes'].setValue(0)
    }
    if (t.productTypeId === 19) {
      this.firstForm.controls['sourcetypes'].setValue(0)
    }
    if (t.productTypeId === 18) {
      this.firstForm.controls['sourcetypes'].setValue(0)
    }
    setTimeout(() => {
      if (
        this.cdr !== null &&
        this.cdr !== undefined &&
        !(this.cdr as ViewRef).destroyed
      ) {
        this.firstForm.controls['SplitRepId'].setErrors(null)
        this.cdr.detectChanges()
      }
    }, 250)
    const PauseEachLine = of(null)
    merge(
      PauseEachLine.pipe(
        map(() => this.show()),
        delay(100),
      ),
    )
    return
  }

  selectValsplit(srp: any) {
    this.sourceoffundsstring = srp.label
    this.showtrue = false
    if (srp === 'true') {
      this.showsplit = true
      this.firstForm.controls['SplitRepId'].setValue('')
      return
    } else {
      this.showsplit = false
      this.firstForm.controls['SplitRepId'].setValue(0)
      return
    }
  }
  async sourceCheckTimeSelect(source: string): Promise<null> {
    if (this.selectedSourceOfFunds.length === 0) {
      this.selectedSourceOfFunds = source;
    }
     this.sourceoffundsstring = source;

    if (this.selectedSourceOfFunds !== source) {
      this.selectedSourceOfFunds = source;
      this.firstForm.controls['sourcetypes'].setErrors({ incorrect: true });
      this.osjValid = await this.osjValidator(source);

      const repControl = this.firstForm.get('RepId');
      this.sourceoffundsstring = source;

      // ─── date-fns version ───────────────────────────────────
      const timezone = 'America/New_York';
      const nowInNY = toZonedTime(new Date(), timezone);
      const cutoffInNY = set(nowInNY, {
        hours: 13,
        minutes: 59,
        seconds: 59,
        milliseconds: 0,
      });
      // ──────────────────────────────────────────────────────────

      const repId = repControl.value;
      const rep: repingDto = await this.cliservice.getRepByIdAsync({ repId });

      // replace moment.isAfter with date-fns isAfter
      if (source === 'Check' && isAfter(nowInNY, cutoffInNY)) {
        if (!rep.overrideOsjwarning) {
          this.checkWarning = true;
        }
      } else {
        this.checkWarning = false;
      }

      return null;
    }

    return null;
  }

  isAfterOrBeforeTime(hour: number, before: boolean): boolean {
    const timezone = 'America/New_York';

    // “Now” stamped into NY time
    const nowInNY = toZonedTime(new Date(), timezone);

    // Today at (hour−1):59:59 in NY
    const cutoffInNY = set(
      toZonedTime(new Date(), timezone),
      {
        hours: hour - 1,
        minutes: 59,
        seconds: 59,
        milliseconds: 0
      }
    );

    return before
      ? isBefore(nowInNY, cutoffInNY)
      : isAfter(nowInNY, cutoffInNY);
  }
  public osjValidator = async (sourceType) => {
    // ##############  Get Current Role.  ###################
    const paramT = crypto.AES.decrypt(
      this.storageValueReturn.trim(),
      `${environment.securepw.trim()}`,
    ).toString(crypto.enc.Utf8)
    const checkParamT = decodeURI(paramT) // ##############  Get Current Role.  ###################
    if (checkParamT === 'REP') {
      this.RepExists = false
    }
    const currentRole = checkParamT
    const dateTime = new Date()
    const byHour = new Date(dateTime)
    const prodControl = this.firstForm.get('productTypeId')
    const repControl = this.firstForm.get('RepId')
    const transControl = this.firstForm.get('transact')
    const transId = transControl.value
    const getvalues = this.productlisting.filter(
      (t) => t.productTypeId === prodControl.value,
    )
    for (const i in getvalues) {
      this.newosjresult = getvalues[i].overrideOsjwarning
    }
    if (
      (currentRole.toLowerCase() &&
        currentRole != null &&
        Number(byHour.getHours) > Number(this.newosjresult)) ||
      (Number(byHour.getHours) < 5 &&
        [1, 2, 7].includes(transId) &&
        ['rep', 'branch access non manager', 'branch manager'].includes(
          currentRole.toLowerCase(),
        ))
    ) {
      if (sourceType != null) {
        const source = this.sourceFundtypelist.find(
          (y) => y.sourceOfFundsTypeDesc == sourceType,
        )
        const repId = repControl.value
        const sourceTypeValue = source.sourceOfFundsTypeId
        const rep: repingDto = await this.cliservice.getRepByIdAsync({
          repId: repId,
        })
        if (
          !rep.overrideOsjwarning &&
          rep.officeTypeId !== 2 &&
          (sourceTypeValue === 1 || sourceTypeValue === 9)
        ) {
          return true
        }
        return false
      }
    }
    return null;
  }

  /* ##################  Onload method ######################## */
  async osjValidatorload() {
    // ##############  Get Current Role.  ###################
    const paramT = crypto.AES.decrypt(
      this.storageValueReturn.trim(),
      `${environment.securepw.trim()}`,
    ).toString(crypto.enc.Utf8)
    const checkParamT = decodeURI(paramT) // ##############  Get Current Role.  ###################
    if (checkParamT.toLowerCase() === 'rep'.toLowerCase()) {
      this.RepExists = false
    }
    const currentRole = checkParamT
    const dateTime = new Date()
    const byHour = new Date(dateTime)
    const prodControl = this.firstForm.get('productTypeId')
    const repControl = this.firstForm.get('RepId')
    const transControl = this.firstForm.get('transact')
    const transId = transControl.value
    const getvalues = this.productlisting.filter(
      (t) => t.productTypeId === prodControl.value,
    )
    for (const i in getvalues) {
      this.newosjresult = getvalues[i].overrideOsjwarning
    }
    if (
      (currentRole &&
        currentRole != null &&
        Number(byHour.getHours) > Number(this.newosjresult)) ||
      (Number(byHour.getHours) < 5 &&
        [1, 2, 7].includes(transId) &&
        ['rep', 'branch access non manager', 'branch manager'].includes(
          currentRole.toLowerCase(),
        ))
    ) {
      const sourceType = this.productlisting.filter(
        (t) => t.productTypeId === prodControl.value,
      )
      if (sourceType != null) {
        const source = this.sourceFundtypelist.find(
          (y) => y.sourceOfFundsTypeDesc == sourceType,
        )
        const repId = repControl.value
        const sourceTypeValue = source.sourceOfFundsTypeId
        const rep: repingDto = await this.cliservice.getRepByIdAsync({
          repId: repId,
        })
        if (
          !rep.overrideOsjwarning &&
          rep.officeTypeId !== 2 &&
          (sourceTypeValue === 1 || sourceTypeValue === 9)
        ) {
          this.osjValid = true
          return true
        }
        this.osjValid = false
        return false
      }
      this.cdr.detectChanges()
    }
    return null;
  }

  ngDestroy() {
    this.unsubcribe()
  }
  showchange() {
    this.repwasterminated = false
    this.RepSelected = this.getRepId
      ? this.getRepId
      : this.firstForm.value.RepId
    this.lblRep = this.firstForm.value.transact
    this.ClientSelected = this.getClientId
      ? this.getClientId
      : this.firstForm.value.clientTax
    const param = {
      clientId: this.ClientSelected,
      repId: this.RepSelected,
      clientname: this.Clientstring,
    }
    this.passclientId.emit(param)
    this.productTypeSelected =
      this.firstForm.value.productTypeId !== undefined
        ? this.firstForm.value.producTypeId
        : this.producttypeIdEdit
    if (this.productTypeSelected === undefined) {
      this.productTypeSelected = this.firstForm.value.productTypeId
    }
    this.transactionTypeSelected = this.firstForm.value.transact
    this.SourceofFundsSelected = this.firstForm.value.sourcetypes
    this.RepCodeSelected = this.firstForm.value.repCodeId
    this.repCodestring = this.repcodelistItems.find(
      (f) => f.repCodeId === this.firstForm.value.repCodeId,
    )?.repCode
    this.productTypestring = this.productlisting.find(
      (f) => f.productTypeId === this.productTypeSelected,
    )?.productTypeDesc2
    this.transactionTypestring = this.translisting.find(
      (f) => f.transactionTypeId === this.transactionTypeSelected,
    )?.transactionTypeDesc
    this.sourceoffundsstring =
      this.SourceofFundsSelected === 0
        ? ''
        : this.sourceFundtypelist.find(
          (f) => f.sourceOfFundsTypeId === this.SourceofFundsSelected,
        )?.sourceOfFundsTypeDesc
    this.osjValidatorload()
  }
}
